module.exports = __webpack_public_path__ + "img/soul_ring.359a6fbe.png";